import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

interface Props {
  open: boolean;
  ruleName: string;
  matchInfo: string;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteRuleDialog({ open, ruleName, matchInfo, onClose, onConfirm }: Props) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Delete Rate Rule</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete <strong>{ruleName}</strong>?
        </Typography>
        <Typography color="error" sx={{ mt: 2 }}>
          Incoming rates matching <strong>{matchInfo}</strong> will no longer resolve until a replacement rule is
          created.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="error" onClick={onConfirm}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
